import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import SalePrice from "../../../entities/SalePrice";
import SalePriceItemType from "../../../entities/SalePriceItemType";
import {SalePriceService} from "../../../service/SalePriceService";

const PAGE_SIZE = 100000;

class CopyServicePricesStore {

    public sourceSalePriceId: string;
    public serviceName: SalePriceItemType;
    public salePrices: SalePrice[];
    public selectedTargetIds: string[];
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, sourceSalePriceId: string, serviceName: SalePriceItemType) {
        this.sourceSalePriceId = sourceSalePriceId;
        this.serviceName = serviceName;
        this.salePrices = [];
        this.selectedTargetIds = [];
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    get targetSalePrices(): SalePrice[] {
        return this.salePrices.filter(t => t.id !== this.sourceSalePriceId);
    }

    get enableButton(): boolean {
        return this.selectedTargetIds.length > 0;
    }

    @action
    public toggleTarget(salePriceId: string, checked: boolean) {
        if (checked) {
            this.selectedTargetIds = [...this.selectedTargetIds, salePriceId];
        } else {
            this.selectedTargetIds = this.selectedTargetIds.filter(t => t !== salePriceId);
        }
    }

    @action
    public toggleTargets(salePriceIds: string[], checked: boolean) {
        if (checked) {
            const newIds = salePriceIds.filter(id => !this.selectedTargetIds.includes(id));
            this.selectedTargetIds = [...this.selectedTargetIds, ...newIds];
        } else {
            this.selectedTargetIds = this.selectedTargetIds.filter(id => !salePriceIds.includes(id));
        }
    }

    @action
    public async loadSalePrices() {
        const response = await SalePriceService.get(1, PAGE_SIZE);
        if (response.success && response.data) {
            this.salePrices = response.data.data;
        }
        this.commonStore.processErrors(response);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.selectedTargetIds = [];
        await this.loadSalePrices();
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        const response = await SalePriceService.copyServicePrices(this.sourceSalePriceId, this.selectedTargetIds, this.serviceName);
        this.commonStore.processErrors(response);
        this.loading = false;
        if (response.success) {
            await this.commonStore.showSuccessToast('Precios copiados exitosamente');
        }
        return response.success;
    }
}

export default CopyServicePricesStore;
